import _definePage_default_0 from '/home/app-testes-brf/htdocs/testes.brf.infotech.app.br/resources/js/pages/[...error].vue?definePage&vue'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from '/home/app-testes-brf/htdocs/testes.brf.infotech.app.br/resources/js/pages/contratos/index.vue?definePage&vue'
import _definePage_default_3 from '/home/app-testes-brf/htdocs/testes.brf.infotech.app.br/resources/js/pages/contratos/[id].vue?definePage&vue'
import _definePage_default_4 from '/home/app-testes-brf/htdocs/testes.brf.infotech.app.br/resources/js/pages/contratos/novo.vue?definePage&vue'
import _definePage_default_5 from '/home/app-testes-brf/htdocs/testes.brf.infotech.app.br/resources/js/pages/home.vue?definePage&vue'
import _definePage_default_6 from '/home/app-testes-brf/htdocs/testes.brf.infotech.app.br/resources/js/pages/login.vue?definePage&vue'
import _definePage_default_7 from '/home/app-testes-brf/htdocs/testes.brf.infotech.app.br/resources/js/pages/not-authorized.vue?definePage&vue'
import _definePage_default_8 from '/home/app-testes-brf/htdocs/testes.brf.infotech.app.br/resources/js/pages/prestadores/index.vue?definePage&vue'
import _definePage_default_9 from '/home/app-testes-brf/htdocs/testes.brf.infotech.app.br/resources/js/pages/prestadores/[id].vue?definePage&vue'
import _definePage_default_10 from '/home/app-testes-brf/htdocs/testes.brf.infotech.app.br/resources/js/pages/prestadores/novo.vue?definePage&vue'
import _definePage_default_11 from '/home/app-testes-brf/htdocs/testes.brf.infotech.app.br/resources/js/pages/rdo/index.vue?definePage&vue'
import _definePage_default_12 from '/home/app-testes-brf/htdocs/testes.brf.infotech.app.br/resources/js/pages/rdo/[id].vue?definePage&vue'
import _definePage_default_13 from '/home/app-testes-brf/htdocs/testes.brf.infotech.app.br/resources/js/pages/rdo/cliente/[id].vue?definePage&vue'

export const routes = [
  _mergeRouteRecord(
  {
    path: '/:error(.*)',
    name: '$error',
    component: () => import('/home/app-testes-brf/htdocs/testes.brf.infotech.app.br/resources/js/pages/[...error].vue'),
    /* no children */
  },
  _definePage_default_0
  ),
  {
    path: '/contratos',
    /* internal name: 'contratos' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'contratos',
        component: () => import('/home/app-testes-brf/htdocs/testes.brf.infotech.app.br/resources/js/pages/contratos/index.vue'),
        /* no children */
      },
  _definePage_default_2
  ),
  _mergeRouteRecord(
      {
        path: ':id',
        name: 'contratos-id',
        component: () => import('/home/app-testes-brf/htdocs/testes.brf.infotech.app.br/resources/js/pages/contratos/[id].vue'),
        /* no children */
      },
  _definePage_default_3
  ),
  _mergeRouteRecord(
      {
        path: 'novo',
        name: 'contratos-novo',
        component: () => import('/home/app-testes-brf/htdocs/testes.brf.infotech.app.br/resources/js/pages/contratos/novo.vue'),
        /* no children */
      },
  _definePage_default_4
  )
    ],
  },
  _mergeRouteRecord(
  {
    path: '/home',
    name: 'home',
    component: () => import('/home/app-testes-brf/htdocs/testes.brf.infotech.app.br/resources/js/pages/home.vue'),
    /* no children */
  },
  _definePage_default_5
  ),
  _mergeRouteRecord(
  {
    path: '/login',
    name: 'login',
    component: () => import('/home/app-testes-brf/htdocs/testes.brf.infotech.app.br/resources/js/pages/login.vue'),
    /* no children */
  },
  _definePage_default_6
  ),
  _mergeRouteRecord(
  {
    path: '/not-authorized',
    name: 'not-authorized',
    component: () => import('/home/app-testes-brf/htdocs/testes.brf.infotech.app.br/resources/js/pages/not-authorized.vue'),
    /* no children */
  },
  _definePage_default_7
  ),
  {
    path: '/prestadores',
    /* internal name: 'prestadores' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'prestadores',
        component: () => import('/home/app-testes-brf/htdocs/testes.brf.infotech.app.br/resources/js/pages/prestadores/index.vue'),
        /* no children */
      },
  _definePage_default_8
  ),
  _mergeRouteRecord(
      {
        path: ':id',
        name: 'prestadores-id',
        component: () => import('/home/app-testes-brf/htdocs/testes.brf.infotech.app.br/resources/js/pages/prestadores/[id].vue'),
        /* no children */
      },
  _definePage_default_9
  ),
  _mergeRouteRecord(
      {
        path: 'novo',
        name: 'prestadores-novo',
        component: () => import('/home/app-testes-brf/htdocs/testes.brf.infotech.app.br/resources/js/pages/prestadores/novo.vue'),
        /* no children */
      },
  _definePage_default_10
  )
    ],
  },
  {
    path: '/rdo',
    /* internal name: 'rdo' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'rdo',
        component: () => import('/home/app-testes-brf/htdocs/testes.brf.infotech.app.br/resources/js/pages/rdo/index.vue'),
        /* no children */
      },
  _definePage_default_11
  ),
  _mergeRouteRecord(
      {
        path: ':id',
        name: 'rdo-id',
        component: () => import('/home/app-testes-brf/htdocs/testes.brf.infotech.app.br/resources/js/pages/rdo/[id].vue'),
        /* no children */
      },
  _definePage_default_12
  ),
      {
        path: 'cliente',
        /* internal name: 'rdo-cliente' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':id',
            name: 'rdo-cliente-id',
            component: () => import('/home/app-testes-brf/htdocs/testes.brf.infotech.app.br/resources/js/pages/rdo/cliente/[id].vue'),
            /* no children */
          },
  _definePage_default_13
  )
        ],
      }
    ],
  }
]
